import { UserType } from '../../../../data-access/session/src/lib/state/session-user-type-service.service';
export const permissionsList = [
    {
        title: 'Permission.Title.OfferGroup',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'offer_management',
        permissions: [
            {
                key: 'UI_OfferCampaigns_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_OfferCampaigns_Manage',
                    'UI_OfferCampaigns_ManagePromotionRules',
                    'UI_OfferCampaigns_ManageBlockingRules',
                    // 'UI_OfferCampaigns_ManageRevenueRules',
                    'UI_OfferCampaigns_Suspend',
                    'UI_OfferCampaigns_ApproveRequest',
                ],
            },
            {
                key: 'UI_OfferCampaigns_Manage',
                name: 'Permission.Name.ManageCampaigns',
            },
            {
                key: 'UI_OfferCampaigns_ManagePromotionRules',
                name: 'Permission.Name.ManageOfferAccess',
            },
            {
                key: 'UI_OfferCampaigns_ManageBlockingRules',
                name: 'Permission.Name.ManageBlockingRules',
            },
            // {
            //   key: 'UI_OfferCampaigns_ManageRevenueRules',
            //   name: 'Permission.Name.ManageRevenueRules',
            // },
            {
                key: 'UI_OfferCampaigns_Suspend',
                name: 'Permission.Name.Suspend',
            },
            {
                key: 'UI_OfferCampaigns_ApproveRequest',
                name: 'Permission.Name.ApproveRequest',
            },
        ],
        tooltip: 'Permission.Tooltip.OfferGroup',
    },
    {
        title: 'Permission.Title.UserOperations',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'user_operations',
        permissions: [
            {
                key: 'UI_UserOperations_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_UserOperations_Manage',
                    'UI_UserOperations_Approve',
                    'UI_UserOperations_Ban',
                    'UI_UserOperations_CreateUser',
                ],
            },
            {
                key: 'UI_UserOperations_Manage',
                name: 'Permission.Name.Manage',
            },
            {
                key: 'UI_UserOperations_Approve',
                name: 'Permission.Name.ApproveOwnUsers',
                excludeRoles: [UserType.Admin],
            },
            {
                key: 'UI_UserOperations_Approve',
                name: 'Permission.Name.ApproveAllUsers',
                excludeRoles: [UserType.Manager],
            },
            {
                key: 'UI_UserOperations_Ban',
                name: 'Permission.Name.Ban',
            },
            {
                key: 'UI_UserOperations_CreateUser',
                name: 'Permission.Name.AddNewUser',
            },
        ],
        tooltip: 'Permission.Tooltip.UserOperations',
    },
    {
        title: 'Permission.Title.Postbacks',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'postback_management',
        permissions: [
            {
                key: 'UI_Postback_View',
                name: 'Permission.Name.ViewPostback',
                childrenPermissions: ['UI_Postback_Manage'],
            },
            {
                key: 'UI_Postback_Manage',
                name: 'Permission.Name.ManagePostback',
            },
        ],
        tooltip: 'Permission.Tooltip.Postbacks',
    },
    {
        title: 'Permission.Title.AffiliateBilling',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'affiliate_billing',
        permissions: [
            {
                key: 'UI_Billing_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_Billing_ManagePayouts',
                    'UI_Billing_Create',
                    'UI_Billing_ManageInvoices',
                    'UI_Billing_ManageTransactions',
                    'UI_Billing_RestorePayments',
                ],
            },
            {
                key: 'UI_Billing_ManagePayouts',
                name: 'Permission.Name.ManagePayouts',
                excludeRoles: [UserType.Affiliate],
            },
            {
                key: 'UI_Billing_Create',
                name: 'Permission.Name.CreatePayout',
                excludeRoles: [UserType.Affiliate],
            },
            {
                key: 'UI_Billing_ManageInvoices',
                name: 'Permission.Name.ManageInvoices',
            },
            {
                key: 'UI_Billing_ManageTransactions',
                name: 'Permission.Name.ManageTransactions',
                excludeRoles: [UserType.Affiliate],
            },
            {
                key: 'UI_Billing_RestorePayments',
                name: 'Permission.Name.RestorePayments',
                excludeRoles: [UserType.Affiliate],
            },
        ],
        tooltip: 'Permission.Tooltip.AffiliateBilling',
    },
    {
        title: 'Permission.Title.CRG',
        roles: [UserType.Admin, UserType.Manager, UserType.Affiliate],
        feature: 'crg',
        permissions: [
            {
                key: 'UI_CRG_View',
                name: 'Permission.Name.View',
            },
        ],
    },
    {
        title: 'Permission.Title.EPL',
        roles: [UserType.Admin, UserType.Manager, UserType.Affiliate],
        feature: 'epl',
        permissions: [
            {
                key: 'UI_EPL_View',
                name: 'Permission.Name.View',
            },
        ],
    },
    {
        title: 'Permission.Title.AffiliateClickBilling',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'click_commissions',
        permissions: [
            {
                key: 'UI_ClickBilling_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_ClickBilling_ManagePayouts',
                    'UI_ClickBilling_Create',
                    'UI_ClickBilling_ManageInvoices',
                    'UI_ClickBilling_ManageTransactions',
                    'UI_ClickBilling_RestorePayments',
                ],
            },
            {
                key: 'UI_ClickBilling_ManagePayouts',
                name: 'Permission.Name.ManagePayouts',
            },
            {
                key: 'UI_ClickBilling_Create',
                name: 'Permission.Name.CreatePayout',
            },
            {
                key: 'UI_ClickBilling_ManageInvoices',
                name: 'Permission.Name.ManageInvoices',
            },
            {
                key: 'UI_ClickBilling_ManageTransactions',
                name: 'Permission.Name.ManageTransactions',
            },
            {
                key: 'UI_ClickBilling_RestorePayments',
                name: 'Permission.Name.RestorePayments',
            },
        ],
        tooltip: 'Permission.Tooltip.AffiliateClickBilling',
    },
    {
        title: 'Permission.Title.AdvertiserBilling',
        roles: [UserType.Admin],
        feature: 'advertiser_billing',
        permissions: [
            {
                key: 'UI_AdvertiserBilling_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_AdvertiserBilling_ManagePayments',
                    'UI_AdvertiserBilling_ManageInvoices',
                    'UI_AdvertiserBilling_ManageTransactions',
                ],
            },
            {
                key: 'UI_AdvertiserBilling_ManagePayments',
                name: 'Permission.Name.ManagePayments',
            },
            {
                key: 'UI_AdvertiserBilling_ManageInvoices',
                name: 'Permission.Name.ManageInvoices',
            },
            {
                key: 'UI_AdvertiserBilling_ManageTransactions',
                name: 'Permission.Name.ManageTransactions',
            },
        ],
        tooltip: 'Permission.Tooltip.AdvertiserBilling',
    },
    {
        title: 'Global.Navigation.PayoutRules',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'payout_rules',
        permissions: [
            {
                key: 'UI_PayoutRules_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_PayoutRules_Manage'],
            },
            {
                key: 'UI_PayoutRules_Manage',
                name: 'Permission.Name.Manage',
                excludeRoles: [UserType.Affiliate],
            },
        ],
        tooltip: 'Permission.Tooltip.PayoutRules',
    },
    {
        title: 'Permission.Title.RevenueRules',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'revenue_rules',
        permissions: [
            {
                key: 'UI_RevenueRules_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_RevenueRules_Manage'],
            },
            {
                key: 'UI_RevenueRules_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
        tooltip: 'Permission.Tooltip.RevenueRules',
    },
    {
        title: 'Permission.Title.ClickPayoutRules',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'click_commissions',
        permissions: [
            {
                key: 'UI_ClickPayoutRules_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_RevenueRules_Manage'],
            },
            {
                key: 'UI_ClickPayoutRules_Manage',
                name: 'Permission.Name.Manage',
                excludeRoles: [UserType.Affiliate],
            },
        ],
        tooltip: 'Permission.Tooltip.ClickPayoutRules',
    },
    {
        title: 'Global.Navigation.MarketingCampaigns',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'marketing_campaigns',
        permissions: [
            {
                key: 'UI_SmartLinks_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_SmartLinks_Manage', 'UI_SmartLinks_Suspend'],
            },
            {
                key: 'UI_SmartLinks_Manage',
                name: 'Permission.Name.Manage',
            },
            {
                key: 'UI_SmartLinks_Suspend',
                name: 'Permission.Name.Suspend',
            },
        ],
        tooltip: 'Permission.Tooltip.MarketingCampaigns',
    },
    {
        title: 'Permission.Title.Capacity',
        roles: [UserType.Admin],
        feature: 'capacity',
        permissions: [
            {
                key: 'UI_OfferCapacity_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_OfferCapacity_Manage'],
            },
            {
                key: 'UI_OfferCapacity_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
        tooltip: 'Permission.Tooltip.Capacity',
    },
    {
        title: 'Permission.Title.Capacity',
        roles: [UserType.Admin],
        feature: 'capacity',
        permissions: [
            {
                key: 'UI_Capacity_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_Capacity_Manage'],
            },
            {
                key: 'UI_Capacity_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
        tooltip: 'Permission.Tooltip.Capacity',
    },
    {
        title: 'Permission.Title.ReferralProgram',
        roles: [UserType.Manager, UserType.Admin, UserType.Affiliate],
        feature: 'referral_program',
        permissions: [
            {
                key: 'UI_ReferralProgram_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_ReferralProgram_Manage'],
            },
            {
                key: 'UI_ReferralProgram_Manage',
                name: 'Permission.Name.Manage',
                excludeRoles: [UserType.Affiliate],
            },
        ],
        tooltip: 'Permission.Tooltip.ReferralProgram',
    },
    {
        title: 'Permission.Title.PushBrokersRequests',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'push_brokers',
        permissions: [
            {
                key: 'UI_PushBrokers_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_PushBrokers_Manage'],
            },
            {
                key: 'UI_PushBrokers_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
        tooltip: 'Permission.Tooltip.PushBrokersRequests',
    },
    {
        title: 'Global.Navigation.Reports',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'reports',
        permissions: [
            {
                key: 'UI_Reports_Traffic',
                name: 'Permission.Name.TrafficReport',
            },
            {
                key: 'UI_Reports_Global',
                name: 'Permission.Name.GlobalReport',
                excludeRoles: [UserType.Admin],
            },
            {
                key: 'UI_Reports_Referrer',
                name: 'Permission.Name.ReferrerReport',
            },
            {
                key: 'UI_Reports_Basic',
                name: 'Permission.Name.ViewReport',
                excludeRoles: [UserType.Manager, UserType.Admin],
            },
            {
                key: 'UI_LdsLeadInfo_View',
                name: 'Global.Text.LeadsEmail',
                excludeRoles: [UserType.Manager],
            },
            {
                key: 'UI_LdsEmailInfo_View',
                name: 'Global.Text.EmailInfo',
                excludeRoles: [UserType.Manager],
            },
        ],
        tooltip: 'Permission.Tooltip.Reports',
    },
    {
        title: 'Permission.Title.Statistics',
        roles: [UserType.Manager],
        permissions: [
            {
                key: 'UI_Reports_ShowOnlyClicks',
                name: 'Permission.Name.ShowOnlyClicks',
            },
        ],
        tooltip: 'Permission.Tooltip.Statistics',
    },
    {
        title: 'Permission.Name.ViewOrderSum',
        roles: [UserType.Affiliate],
        feature: 'hide_sale_order_sum',
        permissions: [
            {
                key: 'UI_Order_Sum',
                name: 'Permission.Name.ViewOrderSum',
            },
        ],
    },
    {
        title: 'Global.Navigation.Reports',
        roles: [UserType.Affiliate],
        feature: 'reports',
        permissions: [
            {
                key: 'UI_Reports_Basic',
                name: 'Permission.Name.ViewReport',
            },
        ],
        tooltip: 'Permission.Tooltip.Reports3',
    },
    {
        title: 'Global.Navigation.AutomationRules',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'automation_rules',
        permissions: [
            {
                key: 'UI_AutomationRules_View',
                name: 'Permission.Name.View',
                childrenPermissions: ['UI_AutomationRules_Manage'],
            },
            {
                key: 'UI_AutomationRules_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
        tooltip: 'Permission.AutomationRules.Tooltip',
    },
    {
        title: 'Global.Navigation.PermissionSettings',
        roles: [UserType.Manager, UserType.Admin],
        permissions: [
            {
                key: 'UI_PermissionSettings_View',
                name: 'Permission.Name.View',
                childrenPermissions: [
                    'UI_PermissionSettings_ManageAdmin',
                    'UI_PermissionSettings_ManageTL',
                    'UI_PermissionSettings_ManageManager',
                    'UI_PermissionSettings_ManageAdvertiser',
                    'UI_PermissionSettings_ManageAffiliate',
                ],
            },
            {
                key: 'UI_PermissionSettings_ManageAdmin',
                name: 'Permission.Name.ManageAdmin',
                excludeRoles: [UserType.Affiliate, UserType.Manager],
            },
            {
                key: 'UI_PermissionSettings_ManageManager',
                name: 'Permission.Name.ManageManager',
                excludeRoles: [UserType.Affiliate, UserType.Manager],
            },
            {
                key: 'UI_PermissionSettings_ManageAdvertiser',
                name: 'Permission.Name.ManageAdvertiser',
                excludeRoles: [UserType.Affiliate, UserType.Manager],
            },
            {
                key: 'UI_PermissionSettings_ManageAffiliate',
                name: 'Permission.Name.ManageAffiliate',
                excludeRoles: [UserType.Affiliate],
            },
        ],
        tooltip: 'Permission.Tooltip.PermissionSettings',
    },
    {
        title: 'Permission.Title.Logs',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'logs',
        permissions: [
            {
                key: 'UI_Logs_View',
                name: 'Permission.Name.View',
            },
        ],
    },
    {
        title: 'Permission.Title.Archivation',
        roles: [UserType.Manager, UserType.Admin],
        feature: 'archives',
        permissions: [
            {
                key: 'UI_Archivation_Manage',
                name: 'Permission.Name.Manage',
            },
        ],
    },
    {
        title: 'UI_FraudDetection_View',
        roles: [],
        permissions: [
            {
                key: 'UI_FraudDetection_View',
                name: 'Permission.Name.View',
            },
        ],
    },
    {
        title: 'UI_FraudDetection_Explain',
        roles: [],
        permissions: [
            {
                key: 'UI_FraudDetection_Explain',
                name: 'UI_FraudDetection_Explain',
            },
        ],
    },
    {
        title: 'UI_Enable_Advertiser',
        roles: [],
        permissions: [
            {
                key: 'UI_Enable_Advertiser',
                name: 'UI_Enable_Advertiser',
            },
        ],
    },
    {
        title: 'Permission.Title.LeadStatuses',
        roles: [],
        feature: 'lead_status',
        permissions: [
            {
                key: 'UI_LeadStatus_View',
                name: 'Permission.Name.View',
            },
        ],
    },
];
